import { GeoLookupContext } from '@/contexts/geoLookup';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useContext } from 'react';

export function useGeoLookupContext() {
  const { trackEvent } = useAnalyticsContext();

  const ctx = useContext(GeoLookupContext);

  if (ctx === undefined) {
    throw new Error('useGeoLookupContext must be used within a GeoLookupContext');
  }

  const trackEventWithGeolocation = (
    eventName: string,
    properties: Record<string, string | boolean | Date | unknown>,
  ) => {
    return trackEvent(eventName, {
      ...properties,
      ...(ctx && {
        region: ctx.region,
        country: ctx.country,
        city: ctx.city,
      }),
    });
  };

  return {
    ...ctx,
    trackEventWithGeolocation,
  };
}
